module.exports = __webpack_public_path__ + "img/takadanobaba.b5f09370.jpg";